"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = props => {
  const {
    isDisabled,
    color = 'primary',
    isChecked = false
  } = props;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    themeColors,
    direction
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const ccToggleSwitchStyle = (0, _react.useMemo)(() => {
    const disabledProps = () => {
      if (isDisabled) {
        return {
          opacity: '.5',
          pointerEvents: 'none',
          cursor: 'default'
        };
      }
      return {};
    };
    const deviceProps = () => {
      const height = isMobileView ? pxToRem(20) : pxToRem(16);
      const width = isMobileView ? pxToRem(34) : pxToRem(26);
      return {
        width,
        height
      };
    };
    const getSliderWidth = function () {
      let isOppositeDirection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      const sign = isOppositeDirection ? -1 : 1;
      const width = isMobileView ? pxToRem(sign * 14) : pxToRem(sign * 10);
      return width;
    };
    const toggleSwitchSliderThumbSizeProps = () => {
      let width = getSliderWidth();
      let height = width;
      let bottom = pxToRem(3);
      let right;
      let left;
      if (direction === 'rtl') {
        right = pxToRem(3);
        left = 'auto';
      } else {
        left = pxToRem(3);
        right = 'auto';
      }
      return {
        width,
        height,
        bottom,
        left,
        right
      };
    };
    const toggleSwitchCheckedColorProps = () => {
      if (isChecked) {
        const background = color === 'primary' ? themeColors?.primary.main : themeColors?.basic.dark;
        return {
          background
        };
      }
      return {};
    };
    const ccToggleSwitchSlider = (0, _css.css)({
      position: 'absolute',
      cursor: 'pointer',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: themeColors?.general.border,
      transition: '.4s',
      borderRadius: pxToRem(25),
      ...disabledProps()
    });
    const ccToggleSwitchSliderThumb = (0, _css.css)({
      position: 'absolute',
      content: '""',
      backgroundColor: themeColors?.general.light,
      transition: '.4s',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      ...toggleSwitchSliderThumbSizeProps()
    });
    const ccToggleSwitchSliderThumbIcon = (0, _css.css)({
      display: 'flex',
      justifyContent: 'center'
    });
    const ccToggleSwitch = (0, _css.css)({
      position: 'relative',
      display: 'inline-block',
      ...deviceProps(),
      input: {
        opacity: 0,
        width: 0,
        height: 0,
        ['&:checked + .' + ccToggleSwitchSlider]: {
          ...toggleSwitchCheckedColorProps()
        },
        ['&:checked + .' + ccToggleSwitchSlider + ' .' + ccToggleSwitchSliderThumb]: {
          transform: `translateX(${direction === 'rtl' ? getSliderWidth(true) : getSliderWidth()})`
        }
      }
    });
    return {
      ccToggleSwitch,
      ccToggleSwitchSlider,
      ccToggleSwitchSliderThumb,
      ccToggleSwitchSliderThumbIcon
    };
  }, [color, direction, isChecked, isDisabled, isMobileView, pxToRem, themeColors?.basic.dark, themeColors?.general.border, themeColors?.general.light, themeColors?.primary.main]);
  return {
    'cc-ToggleSwitch': ccToggleSwitchStyle.ccToggleSwitch,
    'cc-ToggleSwitch__slider': ccToggleSwitchStyle.ccToggleSwitchSlider,
    'cc-ToggleSwitch__slider-thumb': ccToggleSwitchStyle.ccToggleSwitchSliderThumb,
    'cc-ToggleSwitch__slider-thumb-icon': ccToggleSwitchStyle.ccToggleSwitchSliderThumbIcon
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;